<template>
  <footer class="site-footer">
    <div class="footer-container">
      <div class="footer-left">
        <div class="footer-logo" @click="showDialog">
          <router-link to="/">
            <img :src="footerLogoUrl" alt="CoreTrust" />
          </router-link>
        </div>
        <div class="footer-slogan">
          {{ $t('siteFooter.slogan') }}
        </div>
      </div>
      <div class="footer-right">
        <nav class="footer-nav">
          <router-link to="/">{{ $t('siteFooter.companyIntro') }}</router-link>
          <router-link :to="productLink">{{ $t('siteFooter.productIntro') }}</router-link>
          <router-link to="/contact">{{ $t('siteFooter.contact') }}</router-link>
          <router-link to="/partners">{{ $t('siteFooter.partners') }}</router-link>
        </nav>
        <div class="social-links">
          <a href="https://x.com/coretrustreal" target="_blank" class="social-link">
            <img :src="require('@/assets/images/social/twitter.png')" alt="Twitter">
          </a>
          <a href="https://t.me/coretrustreal" target="_blank" class="social-link">
            <img :src="require('@/assets/images/social/telegram.png')" alt="Telegram">
          </a>
          <!-- <router-link to="#" target="_blank" class="social-link">
            <img :src="require('@/assets/images/social/facebook.png')" alt="Facebook">
          </router-link> -->
        </div>
      </div>
    </div>
    <network-switch-dialog  ref="networkDialog"></network-switch-dialog>
  </footer>
</template>

<script>
import NetworkSwitchDialog from './NetworkSwitchDialog.vue';
export default {
  name: 'SiteFooter',
  components: {
    NetworkSwitchDialog,
  },
  data() {
    return {
      network: false,
      footerLogoUrl: require('@/assets/images/logo-white.png'),
      productLink: '/product/featured',
    };
  },
  mounted() {
    if(localStorage.getItem('networkSwitch'))  {
      this.network = true;
    }
  },
  methods: {
    showDialog() {
      if(this.network) {
        this.$refs.networkDialog.dialog = true;
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .footer-slogan{
    font-size: 12px;
    text-align: left
  }
  .footer-nav a{
    font-size: 12px;
  }
}
</style>
